<div
  class="tw-grid tw-grid-cols-6 tw-justify-center tw-items-center tw-place-items-center tw-rounded-tl-sm tw-rounded-tr-sm tw-gap-[24px]"
>
  @for (otp of otps; let i = $index; track i) {
    <input
      class="tw-w-[52px] tw-h-10 tw-bg-zinc-100 focus:tw-outline-none focus:!tw-border-b-2 focus:!tw-border-b-blue-700 tw-text-center otp-input"
      (input)="checkInputLength($event)"
      maxlength="1"
      type="number"
      (keyup)="onOTPEntered($event)"
      (paste)="onOTPPasted($event)"
    />
  }
</div>
